import React from 'react';
import { RoundButton } from '../ClinicQueue/QueueBadge';

type Props = {
  onClickShowDescription: () => void;
  onClickShowActions: () => void;
};

const QueueBadgeMobileActionButtons = (props: Props) => {
  return (
    <div className="expand-button-wrapper absolute left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] z-10 flex gap-2">
      <RoundButton
        src="memo-pad"
        className="blue"
        onClick={(ev: MouseEvent) => {
          props.onClickShowDescription();
          ev.stopPropagation();
        }}
      />
      <RoundButton
        src={['fas', 'ellipsis-vertical']}
        className="blue"
        onClick={(ev: MouseEvent) => {
          props.onClickShowActions();
          ev.stopPropagation();
        }}
      />
    </div>
  );
};

export default QueueBadgeMobileActionButtons;
